import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { BsSearch } from 'react-icons/bs';
import styles from '../styles/SearchBar.module.scss';

const SearchBar = ({ onSearch }) => {
    const [searchTerm, setSearchTerm] = useState('');

    const handleInputChange = (event) => {
        const value = event.target.value;
        setSearchTerm(value);
        onSearch(value); // Call onSearch directly for dynamic filtering
    };

    return (
        <div className={styles.searchBarContainer}>
            <input
                type="text"
                value={searchTerm}
                onChange={handleInputChange}
                placeholder="Buscar productos..."
                className={styles.searchInput}
            />
            <button onClick={() => onSearch(searchTerm)} className={styles.searchButton}>
                <BsSearch />
            </button>
        </div>
    );
};

SearchBar.propTypes = {
    onSearch: PropTypes.func.isRequired,
};

export default SearchBar;
